import React from "react";
import { DatePicker } from "@material-ui/pickers";
import { DatePickerView } from "@material-ui/pickers/DatePicker/DatePicker";
import _ from "lodash";

import { useField } from "../Form/useField";

type Props = {
  label: string;
  className?: string;
  name: string;
  required?: boolean;
  defaultValue?: string | null;
  format: string;
  views?: DatePickerView[];
  placeholder?: string;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
  ToolbarComponent?: (props: any) => JSX.Element;
};

const DatePickerField: React.FC<Props> = ({
  label,
  name,
  required,
  defaultValue,
  className,
  format,
  views,
  placeholder = "",
  disabled,
  minDate,
  maxDate,
  ToolbarComponent
}) => {
  const { value, onChange } = useField({
    name,
    required,
    defaultValue: _.isNil(defaultValue) ? null : defaultValue
  });

  return (
    <DatePicker
      className={className}
      format={format}
      InputLabelProps={{ shrink: true }}
      label={`${label} ${required ? "*" : ""}`}
      onChange={onChange}
      placeholder={placeholder}
      variant="inline"
      autoOk
      ToolbarComponent={ToolbarComponent}
      value={value}
      views={views}
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
    />
  );
};

export default DatePickerField;
